import { Link } from "react-router-dom";

export default function DisclosurePolicy() {
  return (
    <section data-testid="disclosure-section" className="space-y-6 max-w-3xl">
      <h1 className="hs-display text-3xl md:text-4xl">Disclosure policy</h1>
      <p className="text-muted">
        HerdSafe is a neutral early-warning network. We don't publish confirmed items until
        maintainers or the registry have had a reasonable window to acknowledge or remove
        the problematic content.
      </p>
      <ol className="list-decimal space-y-3 pl-6 text-muted">
        <li>
          A rules-plus-LLM pipeline marks an item <code className="hs-mono">suspected</code>; a human reviewer confirms or clears.
        </li>
        <li>
          On confirmation we notify the registry or maintainer through a public contact channel —
          email, GitHub issue, or registry report — and open a disclosure record.
        </li>
        <li>
          We publish once either the item is removed/acknowledged <em>or</em> 30 days have passed
          with no response. All evidence published is redacted (summary + payload hash).
        </li>
        <li>
          Appeals are reviewed within 5 business days. Upheld appeals re-queue the item for
          human reclassification — the public tier never auto-reverts without a human.
        </li>
      </ol>
      <p className="text-muted">
        File an appeal at <Link to="/appeal" className="hs-link">/appeal</Link>.
      </p>
    </section>
  );
}
